<!-- 左虾饺 -->
<template>
    <div class='bg box_v'>
        <div class="title">月访问情况</div>
        <div class='box_f1' id="echart3" style="width:100%;height:100%"></div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            accessData:[],
            accessTag:'',
            mon:[]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.monthAccess).then(res=>{
                let accessCount = res.rows.map(item=>item.accessCount)
                this.accessData = this.$util.handleNumber(accessCount).numArr
                this.accessTag = this.$util.handleNumber(accessCount).tag
                this.mon = res.rows.map(item=>item.mon)
                this.$nextTick(()=>{
                    this.initEcharts()
                })
            })
        },
        initEcharts(){
            let echart2 = echarts.init(document.getElementById('echart3'));
           
            let option = {
                xAxis: {
                    type: 'category',
                    data: this.mon,
                    barCategoryGap: '15px',                    
                    axisLabel: {
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    axisLine:{show: false}
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        textStyle: {
                            color: '#6BD3FF'
                        },
                        formatter: '{value}' + this.accessTag,
                    },
                    splitLine:{show: false},//去除网格线
                    axisLine:{show: false}
                },
                // legend: {
                //     data: ['实名认证用户量'],
                //     right:'20',
                //     icon:'roundRect',
                //     textStyle:{
                //         color:'#fff'
                //     }
                // },
                series: [{
                    name:'实名认证用户量',
                    data: this.accessData,
                    type: 'line',
                    smooth:true,
                    symbol: 'none',
                    lineStyle:{
                        color:'#00B7EE'
                    },
                    areaStyle:{
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#4884FF' // 0% 处的颜色
                            }, {
                                offset: 1, color: 'rgba(6, 27, 84, 0)' // 100% 处的颜色
                            }],
                            global: false // 缺省为 false
                        }
                    }
                }],
                tooltip:{
                    trigger:'axis',
                    formatter:'{c}'+this.accessTag,
                    backgroundColor:'rgba(255,255,255,0)',
                    textStyle:{
                        color:'#6BD3FF'
                    }
                }
            };
            

            echart2.setOption(option)
            // echart1.on('click', (params)=>{
            //     this.getQyList(params.dataIndex)
            //     console.log(params.dataIndex);
            // });
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.bg{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/leftbottom.png');
    background-size: 100% 100%;
    margin-top:10px;
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin-left: 40px;
    margin-top: 20px
}
</style>